import React, { Fragment } from "react";
import ParseHTML from "html-react-parser";

export const TermsAndConditionsDetails = {
    title: "Review and Accept Service Agreement",
    formLabel: "I agree to the Developer's Agreement",
};
export const tncAgreementVesrion = "1";

export const TermsHTML = () => (
    <Fragment>
        {ParseHTML(
            `<div>
        <p>
          <span style="font-weight: 400;">SingularityNET | </span>
          <strong>Developer</strong>
          <strong>Agreement</strong>
        </p>
        <ol>
          <li>
            <strong> Welcome to Singularitynet</strong>
          </li>
        </ol>
        <p>
          <strong>1.1</strong>
          <span style="font-weight: 400;"> This agreement along with the terms and conditions (&ldquo;</span>
          <strong>TOS</strong>
          <span style="font-weight: 400;">&rdquo;) and the Privacy Policy constitute a contract (&ldquo;</span>
          <strong>Agreement</strong>
          <span style="font-weight: 400;">
            &rdquo;) between you and Stichting SingularityNET, whose registered office is at Barbara Strozzilaan 362,
            1083 HN Amsterdam, the Netherlands (&ldquo;
          </span>
          <strong>SingularityNET</strong>
          <span style="font-weight: 400;">
            &rdquo;). This Agreement governs your participation as an AI developer (&ldquo;
          </span>
          <strong>AI TApp Dev</strong>
          <span style="font-weight: 400;">&rdquo;) with regard to the AI Store (&ldquo;</span>
          <strong>AI Store</strong>
          <span style="font-weight: 400;">
            &rdquo;) &ndash; a decentralized marketplace for Artificial Intelligence (&ldquo;
          </span>
          <strong>AI</strong>
          <span style="font-weight: 400;">
            &rdquo;). Through you can exchange your AI applications, tools and services (&ldquo;
          </span>
          <strong>AI TApp</strong>
          <span style="font-weight: 400;">&rdquo;) for SingularityNET&rsquo; ${process.env.REACT_APP_TOKEN_NAME} token (&ldquo;</span>
          <strong>${process.env.REACT_APP_TOKEN_NAME}</strong>
          <span style="font-weight: 400;">&rdquo;) or even for other tools and services.&nbsp;</span>
        </p>
        <p>
          <strong>1.2</strong>
          <span style="font-weight: 400;">
            Terms found in this Agreement that relate to features or functionality not available in your home country
            (&ldquo;
          </span>
          <strong>Home Country</strong>
          <span style="font-weight: 400;">
            &rdquo;) are not applicable to you unless and until they become available to you.
          </span>
        </p>
        <p>
          <strong>1.3</strong>
          <span style="font-weight: 400;">
            You certify that you are at least 16 years of age and you represent that you are legally permitted to
            register as an AI TApp Dev. If you are younger than 16 ask your parents for AI books, in the meantime.
            Children under the age of majority should review this Agreement with their parent or guardian to ensure that
            the child and parent or legal guardian understand it.
          </span>
        </p>
        <p>
          <strong>1.4</strong>
          <span style="font-weight: 400;">
            We always try our best at what we do and promise that we will exercise reasonable care and skill in
            performing our obligations under this Agreement.&nbsp;
          </span>
        </p>
        <p>
          <strong>1.5</strong>
          <span style="font-weight: 400;">
            This Agreement may be saved and printed through the options of your web browser.
          </span>
        </p>
        <ol start="2">
          <li>
            <strong> Relationship with SingularityNET</strong>
          </li>
        </ol>
        <p>
          <strong>2.1</strong>
          <span style="font-weight: 400;">
            You understand and agree that by registering with SingularityNET to become an AI TApp Dev, no legal
            partnership or agency relationship is created between you and SingularityNET. You agree not to represent
            otherwise. This Agreement is void where prohibited by law and the right to register as an AI TApp Dev is not
            granted in such jurisdictions. Unless otherwise agreed or permitted by SingularityNET in writing, you cannot
            share or transfer any benefits you receive from SingularityNET in connection with being an AI TApp Dev. The
            SingularityNET ID (&ldquo;
          </span>
          <strong>SNET ID</strong>
          <span style="font-weight: 400;">
            &rdquo;) and password you may use to log into your account cannot be shared in any way or with anyone. You
            are responsible for maintaining the confidentiality of your SNET ID and password and for any activity in
            connection with your account.
          </span>
        </p>
        <p>
          <strong>2.1.1</strong>
          <span style="font-weight: 400;">
            AI Store&rsquo;s users need to know how to reach you with questions and support issues. Make sure your AI
            TApp and its support URL include an easy way to contact you. Failure to include accurate and up-to-date
            contact information not only frustrates customers, but may violate the law in some countries.
          </span>
        </p>
        <p>
          <strong>2.1.2 </strong>
          <span style="font-weight: 400;">Unless you provide</span>
          <span style="font-weight: 400;">
            an accepted Custom EULA (as defined in section 5 of the TOS), the license of any AI TApp submitted to the AI
            Store will be regulated in accordance to the EULA in section 5 of the TOS. Therefore, you will grant to the
            AI Store&rsquo;s users, in particular, a license to use the Licensed TApp (as defined in section 5 of the
            TOS) that allows the commercial use. Please contact SingularityNET, if you want to limit the use the
            Licensed TApp to noncommercial.&nbsp;
          </span>
        </p>
        <p>
          <strong>2.2</strong>
          <span style="font-weight: 400;">
            As an AI TApp Dev, you may have the opportunity to attend certain SingularityNET developer conferences,
            technical talks, and other events (&ldquo;
          </span>
          <strong>SNET Events</strong>
          <span style="font-weight: 400;">
            &rdquo;). In addition, SingularityNET may offer to provide you with certain services (&ldquo;
          </span>
          <strong>Services</strong>
          <span style="font-weight: 400;">
            &rdquo;), solely for your own use in connection with your participation as an AI TApp Dev. Services may
            include, but not be limited to, any services SingularityNET offers on the AI Store at SNET Events, as well
            as the offering of any content or materials displayed on the AI Store (&ldquo;
          </span>
          <strong>Content</strong>
          <span style="font-weight: 400;">
            &rdquo;). SingularityNET may change, suspend or discontinue providing the Services to you at any time, and
            may impose limits on certain features and materials offered or restrict your access to parts or all of such
            materials without notice or liability.
          </span>
        </p>
        <ol start="3">
          <li>
            <strong> Use of the AI Store</strong>
          </li>
        </ol>
        <p>
          <strong>3.1</strong>
          <span style="font-weight: 400;">
            Your use of the AI Store must follow the rules set forth in this section (&ldquo;
          </span>
          <strong>Rules</strong>
          <span style="font-weight: 400;">&rdquo;). Any other use is a material breach of this Agreement.&nbsp;</span>
        </p>
        <p>
          <strong>3.2</strong>
          <span style="font-weight: 400;">
            You agree not to exploit the AI Store, or any Services, SNET Events or Content provided to you by
            SingularityNET as an AI TApp Dev, in any unauthorized way, including but not limited to, by trespass,
            burdening network capacity or using the AI Store, the Services, the Content other than for authorized
            purposes. Copyright and other intellectual property laws protect the AI Store, Services and Content provided
            to you, and you agree to abide by and maintain all notices, license information, and restrictions contained
            therein. Unless expressly permitted herein or otherwise permitted in a separate agreement with
            SingularityNET, you may not modify, publish, network, rent, lease, loan, transmit, sell, participate in the
            transfer or sale of, reproduce, create derivative works based on, redistribute, perform, display, or in any
            way exploit any of the AI Store, Services or Content. You may not decompile, reverse engineer, disassemble,
            or attempt to derive the source code of any software or security components of the AI Store, Services, or
            Contents (except as and only to the extent any foregoing restriction is prohibited by applicable law or to
            the extent as may be permitted by any licensing terms accompanying the foregoing). Use of the AI Store,
            Services, or Content to violate, tamper with, or circumvent the security of any computer network, software,
            passwords, encryption codes, technological protection measures, or to otherwise engage in any kind of
            illegal activity, or to enable others to do so, is expressly prohibited. SingularityNET retains ownership of
            all its rights in the AI Store, Services, SNET Events, Content, and except as expressly set forth herein, no
            other rights or licenses are granted or to be implied under any SingularityNET intellectual property.
          </span>
        </p>
        <p>
          <strong>3.3</strong>
          <span style="font-weight: 400;">
            The term AI TApp includes AI tools, services, apps, in-app purchases, extensions, and subscriptions made
            available in an AI TApp.
          </span>
        </p>
        <p>
          <strong>3.4</strong>
          <span style="font-weight: 400;">
            You agree that you will not develop or provide AI TApp whose purposes are prohibited by the law, including,
            without limitation:&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>i</strong>
          <span style="font-weight: 400;">
            ) the development, design, manufacture, or production of nuclear, missile, or chemical or biological
            weapons;&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>ii</strong>
          <span style="font-weight: 400;">
            ) the development, design, manufacture, or production of viral infections that can be transmitted via bites
            or contact with bodily fluids, causing human corpses to reanimate and seek to consume living human flesh,
            blood, brain or nerve tissue;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iii</strong>
          <span style="font-weight: 400;">
            ) the development, design, manufacture, or production of tools that could result in the fall of organized
            civilization;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iv</strong>
          <span style="font-weight: 400;">
            ) the development, design, manufacture, or production of tools that can put people or animals under risks of
            physical or emotional and psychological harm;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>v</strong>
          <span style="font-weight: 400;">
            ) the development, design, manufacture, or production of tools that allow people to impersonate Ben
            Goertzel;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>vi</strong>
          <span style="font-weight: 400;">
            ) the development, design, manufacture, or production of tools to commit terrorist offences.
          </span>
        </p>
        <p>
          <strong>3.5</strong>
          <span style="font-weight: 400;">
            AI TApps should not include content that is offensive, insensitive, upsetting, intended to disgust, or in
            exceptionally poor taste. Examples of such content include:
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>i</strong>
          <span style="font-weight: 400;">
            ) Defamatory, discriminatory, or mean-spirited content, including references or commentary about religion,
            race, sexual orientation, gender, national/ethnic origin, or other targeted groups, particularly if the AI
            TApp is likely to humiliate, intimidate, or place a targeted individual or group in harm&rsquo;s way.&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>ii</strong>
          <span style="font-weight: 400;">
            ) Realistic portrayals of people or animals being killed, maimed, tortured, or abused, or content that
            encourages violence.&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iii</strong>
          <span style="font-weight: 400;">
            ) Depictions that encourage illegal or reckless use of weapons and dangerous objects, or facilitate the
            purchase of firearms.
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iv</strong>
          <span style="font-weight: 400;">) Overtly sexual or pornographic material.</span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>v</strong>
          <span style="font-weight: 400;">
            ) Inflammatory religious commentary or inaccurate or misleading quotations of religious texts.
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>vi</strong>
          <span style="font-weight: 400;">
            ) False information and features, including inaccurate device data or trick/joke functionality, such as fake
            location trackers.&nbsp;
          </span>
        </p>
        <p>
          <strong>3.5.1</strong>
          <span style="font-weight: 400;">
            User Generated Content. To prevent abuse, AI TApps with user-generated content must include:
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>i</strong>
          <span style="font-weight: 400;">
            ) A method for filtering objectionable material from being posted to the AI TApp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>ii</strong>
          <span style="font-weight: 400;">
            ) A mechanism to report offensive or prohibited by the law content and timely responses to concerns;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iii</strong>
          <span style="font-weight: 400;">) The ability to block abusive users from the service;</span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iv</strong>
          <span style="font-weight: 400;">) Published contact information so users can easily reach you.</span>
        </p>
        <p>
          <span style="font-weight: 400;">
            AI TApps with user-generated content or services that end up being used primarily for pornographic content,
            objectification of real people, making physical threats, or bullying do not belong on the AI Store and may
            be removed without notice
          </span>
        </p>
        <p>
          <strong>3.6</strong>
          <span style="font-weight: 400;">
            {" "}
            AI TApps should not behave in a way that risks physical harm. For example:
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>i</strong>
          <span style="font-weight: 400;">
            ) Medical AI TApps that could provide inaccurate data or information, or that could be used for diagnosing
            or treating patients may be reviewed with greater scrutiny. Medical AI TApps must clearly disclose data and
            methodology to support accuracy claims relating to health measurements, and if the level of accuracy or
            methodology cannot be validated, we will reject your AI TApp. Medical AI TApps should remind users to check
            with a doctor in addition to using the AI TApp and before making medical decisions. If your Medical AI TApp
            has received regulatory clearance, please submit a link to that documentation with your AI TApp.
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>ii</strong>
          <span style="font-weight: 400;">
            ) Drug dosage calculators must come from the drug manufacturer, a hospital, university, health insurance
            company, pharmacy or other approved entity, or receive approval by the FDA or one of its international
            counterparts. Given the potential harm to patients, we need to be sure that the AI TApp will be supported
            and updated over the long term.
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iii</strong>
          <span style="font-weight: 400;">
            ) AI TApps that encourage consumption of tobacco products, illegal drugs, or excessive amounts of alcohol
            are not permitted on the AI Store. AI TApps that encourage minors to consume any of these substances will be
            rejected. Facilitating the sale of marijuana, tobacco, or controlled substances (except for licensed
            pharmacies) isn&rsquo;t allowed.
          </span>
        </p>
        <p>
          <strong>3.7</strong>
          <span style="font-weight: 400;">
            AI Store Reviews. AI Store customer reviews can be an integral part of the AI TApp experience, so you should
            treat customers with respect when responding to their comments. Keep your responses targeted to the
            user&rsquo;s comments and do not include personal information, spam, or marketing in your response. Use the
            provided API to prompt users to review your AI TApp; this functionality allows customers to provide an AI
            Store rating and review without the inconvenience of leaving your AI TApp, and we will disallow custom
            review prompts.
          </span>
        </p>
        <p>
          <strong>3.8</strong>
          <span style="font-weight: 400;">
            Nothing in this Agreement will impair SingularityNET&rsquo;s right to develop, acquire, license, market,
            promote or distribute products, software or technologies that perform the same or similar functions as, or
            otherwise compete with, any other products, software or technologies that you may develop, produce, market,
            or distribute. In the absence of a separate written agreement to the contrary, SingularityNET will be free
            to use any information, suggestions or recommendations you provide to SingularityNET pursuant.
          </span>
        </p>
        <ol start="4">
          <li>
            <strong> SingularityNET Labs and Technical Support&nbsp;</strong>
          </li>
        </ol>
        <p>
          <strong>4.1</strong>
          <span style="font-weight: 400;">
            As an AI TApp Dev, you may have access to SingularityNET&rsquo;s software and/or hardware compatibility
            testing and development labs (&ldquo;
          </span>
          <strong>Labs</strong>
          <span style="font-weight: 400;">&rdquo;) and/or developer technical support incidents (&ldquo;</span>
          <strong>Support</strong>
          <span style="font-weight: 400;">
            &rdquo;) that SingularityNET may make available to you from time to time as an AI TApp Dev benefit or for a
            separate fee. You agree that all use of such Labs and Support will be in accordance with
            SingularityNET&rsquo;s usage policies for such services, which are subject to change from time to time, with
            or without prior notice to you. Without limiting the foregoing, SingularityNET may post on the AI Store, its
            website and/or send an email to you with notices of such changes. It is your responsibility to review the AI
            Store, the website and/or check your email address registered with SingularityNET for any such notices. You
            agree that SingularityNET shall not be liable to you or any third party for any modification or cessation of
            such services. As part of the Support, SingularityNET may supply you with certain code snippets, sample
            code, software, and other materials (&ldquo;
          </span>
          <strong>Materials</strong>
          <span style="font-weight: 400;">
            &rdquo;). You agree that any Materials that SingularityNET provides as part of the Support are licensed to
            you and shall be used by you only in accordance with the terms and conditions accompanying the Materials.
            SingularityNET retains ownership of all of its right, title and interest in such Materials and no other
            rights or licenses are granted or to be implied under any SingularityNET&rsquo;s intellectual property. You
            have no right to copy, decompile, reverse engineer, sublicense or otherwise distribute such Materials,
            except as may be expressly provided in the terms and conditions accompanying the Materials.
          </span>
          <strong>
            You agree that when requesting and receiving Support, you will not provide SingularityNET with any
            information, including that incorporated in your software, that is confidential to you or any third party.
            You agree that any notice, legend, or label to the contrary contained in any such Materials provided by you
            to SingularityNET shall be without effect. SingularityNET shall be free to use all such information it
            receives from you in any manner it deems appropriate, subject to any applicable patents or copyrights.
          </strong>
          <span style="font-weight: 400;">
            SingularityNET reserves the right to reject a request for access to Labs or for Support at any time and for
            any reason, in which event SingularityNET may credit you for the rejected lab or support request. You shall
            be solely responsible for any restoration of lost or altered files, data, programs or other materials
            provided.
          </span>
        </p>
        <ol start="5">
          <li>
            <strong> Third-Party Notices and Products</strong>
          </li>
        </ol>
        <p>
          <strong>5.1</strong>
          <span style="font-weight: 400;">
            Third-party software provided by SingularityNET to you as an AI TApp Dev may be accompanied by its own
            licensing terms, in which case such licensing terms will govern your use of that particular third-party
            software. Mention of third-parties and third-party products in any materials, documentation, advertising, or
            promotions provided to you as an AI TApp Dev is for informational purposes only and constitutes neither an
            endorsement nor a recommendation. All third-party product specifications and descriptions are supplied by
            the respective vendor or supplier, and SingularityNET shall have no responsibility with regard to the
            selection, performance, or use of these vendors or products. All understandings, agreements, or warranties,
            if any, take place directly between the vendors and the prospective users.
          </span>
        </p>
        <ol start="6">
          <li>
            <strong> Miscellaneous&nbsp;&nbsp;</strong>
          </li>
        </ol>
        <p>
          <strong>6.1</strong>
          <strong>Warranties and liability</strong>
          <span style="font-weight: 400;">.&nbsp;</span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>i</strong>
          <span style="font-weight: 400;">) </span>
          <strong>
            SingularityNET and its affiliates, subsidiaries, officers, directors, employees, agents, partners, and
            licensors (collectively, &ldquo;SingularityNET&rdquo; for purposes of this section 6.1) do not promise that
            the AI Store, Services, Content (including, functionality or features of the foregoing), Labs, Supports, or
            any other information or materials that you receive hereunder as an AI TApp Dev (collectively, the
            &ldquo;Service&rdquo; for purposes of this section 6.1) will be accurate, reliable, timely, secure, error-
            free or uninterrupted, or that any defects will be corrected. The Service is provided on an
            &ldquo;as-is&rdquo; and &ldquo;as-available&rdquo; basis and the service is subject to change without
            notice. SingularityNET cannot ensure that any content (including files, information or other data) you
            access or download from the Service will be free of viruses, contamination or destructive features. Further,
            SingularityNET does not guarantee any results or identification or correction of problems as part of the
            Service and SingularityNET disclaims any liability related thereto. SingularityNET disclaims all warranties,
            express or implied, including any warranties of accuracy, non-infringement, merchantability and fitness for
            a particular purpose. SingularityNET disclaims any and all liability for the acts, omissions and conduct of
            any third parties in connection with or related to your use of the Service. You assume total responsibility
            and all risks for your use of the Service, including, but not limited to, any information obtained thereon.
            Your sole remedy against SingularityNET for dissatisfaction with the Service is to stop using the Service.
            This limitation of relief is a part of the bargain between the parties. To the extent that SingularityNET
            makes any pre-release software, hardware or other products, Services or information related thereto
            available to you as an AI TApp Dev, you understand that SingularityNET is under no obligation to provide
            updates, enhancements, or corrections, or to notify you of any product or services changes that
            SingularityNET may make, or to publicly announce or introduce the product(s) or service at any time in the
            future.
          </strong>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>ii</strong>
          <span style="font-weight: 400;">) </span>
          <strong>
            To the extent not prohibited by applicable law, in no event will SingularityNET be liable for personal
            injury, or any incidental, special, indirect, consequential or punitive damages whatsoever, including,
            without limitation, damages resulting from delay of delivery, for loss of profits, data, business or
            goodwill, for business interruption or any other commercial damages or losses, arising out of or related to
            this agreement or your use or inability to use the Service, however caused, whether under a theory of
            contract, warranty, tort (including negligence), products liability, or otherwise, even if SingularityNET
            has been advised of the possibility of such damages, and notwithstanding the failure of essential purpose of
            any remedy. In no event shall SingularityNET&rsquo;s total liability to you under this Agreement for all
            damages (other than as may be required by applicable law in cases involving personal injury) exceed the
            amount of one hundred dollars ($100.00).
          </strong>
        </p>
        <p>
          <strong>6.2 SingularityNET&rsquo;s trademarks</strong>
          <span style="font-weight: 400;">
            . The SingularityNET name, the SingularityNET logo and other SingularityNET trademarks, service marks,
            graphics, and logos used in connection with the AI Store, Services and Content are trademarks or registered
            trademarks (&ldquo;
          </span>
          <strong>Trademarks</strong>
          <span style="font-weight: 400;">
            &rdquo;) of SingularityNET. You agree to follow SingularityNET&rsquo;s trademark and copyright guidelines.
            You agree not to use the Trademarks in any way except as expressly authorized in writing by SingularityNET
            in each instance or as permitted in SingularityNET&rsquo;s trademark and copyright guidelines.&nbsp;
          </span>
        </p>
        <p>
          <strong>6.3 Confidentiality&nbsp;</strong>
        </p>
        <p>
          <strong>6.3.1</strong>
          <span style="font-weight: 400;">
            Except as otherwise set forth herein, you agree that any SingularityNET pre-release software, services,
            and/or hardware (including related documentation and materials) provided to you as an AI TApp Dev (&ldquo;
          </span>
          <strong>Pre-Release Materials</strong>
          <span style="font-weight: 400;">
            &rdquo;) and any information disclosed by SingularityNET to you in connection with SNET Events will be
            considered and referred to as &ldquo;
          </span>
          <strong>SNET Confidential Information</strong>
          <span style="font-weight: 400;">
            &rdquo;. Notwithstanding the foregoing, SNET Confidential Information will not include: (i) information that
            is generally and legitimately available to the public through no fault or breach of yours; (ii) information
            that is generally made available to the public by SingularityNET; (iii) information that is independently
            developed by you without the use of any SNET Confidential Information; (iv) information that was rightfully
            obtained from a third party who had the right to transfer or disclose it to you without limitation; or (v)
            any third party software and/or documentation provided to you by SingularityNET and accompanied by licensing
            terms that do not impose confidentiality obligations on the use or disclosure of such software and/or
            documentation.
          </span>
        </p>
        <p>
          <strong>6.3.2</strong>
          <span style="font-weight: 400;">
            Unless otherwise expressly agreed or permitted in writing by SingularityNET, you agree not to disclose,
            publish, or disseminate any SingularityNET Confidential Information to anyone other than to other AI TApp
            Devs who are employees and contractors working for the same entity as you and then only to the extent that
            SingularityNET does not otherwise prohibit such disclosure. Except for your authorized purposes as an AI
            TApp Dev or as otherwise expressly agreed or permitted by SingularityNET in writing, you agree not to use
            SNET Confidential Information in any way, including, without limitation, for your own or any third
            party&rsquo;s benefit without the prior written approval of an authorized representative of SingularityNET
            in each instance. You further agree to take reasonable precautions to prevent any unauthorized use,
            disclosure, publication, or dissemination of SNET Confidential Information. You acknowledge that
            unauthorized disclosure or use of SNET Confidential Information could cause irreparable harm and significant
            injury to SingularityNET that may be difficult to ascertain. Accordingly, you agree that SingularityNET will
            have the right to seek immediate injunctive relief to enforce your obligations under this Agreement in
            addition to any other rights and remedies it may have. If you are required by law, regulation or pursuant to
            the valid binding order of a court of competent jurisdiction to disclose SNET Confidential Information, you
            may make such disclosure, but only if you have notified SingularityNET before making such disclosure and
            have used commercially reasonable efforts to limit the disclosure and to seek confidential, protective
            treatment of such information. A disclosure pursuant to the previous sentence will not relieve you of your
            obligations to hold such information as SNET Confidential Information.&nbsp;
          </span>
        </p>
        <p>
          <strong>6.3.3</strong>
          <span style="font-weight: 400;">
            If SingularityNET provides you with Pre-Release Materials, then subject to your compliance with the terms
            and conditions of this Agreement, SingularityNET hereby grants you a nonexclusive, nontransferable, right
            and license to use the Pre-Release Materials only for the limited purposes set forth in this section;
            provided however that if such Pre-Release Materials are subject to a separate license agreement, you agree
            that the license agreement accompanying such materials in addition to this section of this Agreement shall
            also govern your use of the Pre-Release Materials. You further agree that in the event of any inconsistency
            between this section of this Agreement and the confidentiality restrictions in the license agreement, the
            license agreement shall govern. You agree not to use the Pre-Release Materials for any purpose other than
            testing and/or development by you of a product designed to operate in combination with the same system for
            which the Pre-Release Materials are designed. This Agreement does not grant you any right or license to
            incorporate or make use of any SingularityNET&rsquo;s intellectual property (including for example and
            without limitation, trade secrets, patents, copyrights, trademarks and industrial designs) in any product.
            Except as expressly set forth herein, no other rights or licenses are granted or to be implied under any
            SingularityNET&rsquo;s intellectual property. You agree not to decompile, reverse engineer, disassemble, or
            otherwise reduce the Pre-Release Materials to a human-perceivable form, and you will not modify, network,
            rent, lease, transmit, sell, or loan the Pre-Release Materials in whole or in part.&nbsp;
          </span>
        </p>
        <p>
          <strong>6.4</strong>
          <strong>Entire agreement, severability</strong>
          <span style="font-weight: 400;">
            . This Agreement constitutes the entire agreement between you and SingularityNET with regard to your
            participation as an AI TApp Dev to the AI Store, superseding any prior agreements with respect to the same
            subject matter between you and SingularityNET. SingularityNET reserves the right at any time to modify this
            Agreement and to add new or additional terms or conditions with regard to your participation as an AI TApp
            Dev to the AI Store. Such modifications and additional terms and conditions will be effective immediately
            and incorporated into this Agreement. Your continued use of the AI Store or Services will be deemed
            acceptance thereof. You also may be subject to additional terms and conditions that may apply when you use
            affiliate services, third-party content, third-party software, or additional services. If any part of this
            Agreement is held invalid or unenforceable, that portion shall be construed in a manner consistent with
            applicable law to reflect, as nearly as possible, the original intentions of the parties, and the remaining
            portions shall remain in full force and effect. SingularityNET&rsquo;s failure to enforce any right or
            provisions in this Agreement will not constitute a waiver of such or any other provision. SingularityNET
            will not be responsible for failures to fulfill any obligations due to causes beyond its control.
          </span>
        </p>
        <p>
          <strong>6.4.1</strong>
          <span style="font-weight: 400;">
            No SingularityNET employee or agent has the authority to vary this Agreement.
          </span>
        </p>
        <p>
          <strong>
            6.4.2 SingularityNET may terminate or suspend you as a registered AI TApp Dev at any time in
            SingularityNET&rsquo;s sole discretion
          </strong>
          <span style="font-weight: 400;">. </span>
          <strong>
            If SingularityNET terminates you as a registered AI TApp Dev, SingularityNET reserves the right to deny your
            reapplication at any time in SingularityNET&rsquo;s sole discretion
          </strong>
          <span style="font-weight: 400;">
            . You may terminate your participation as a registered AI TApp Dev at any time, for any reason, by notifying
            SingularityNET in writing of your intent to do so. Upon any termination or, at SingularityNET&rsquo;s
            discretion, suspension, all rights and licenses granted to you by SingularityNET will cease, including your
            right to access the AI Store and the Services, and you agree to destroy any and all SNET Confidential
            Information that is in your possession or control. At SingularityNET&rsquo;s request, you agree to provide
            certification of such destruction to SingularityNET.
          </span>
          <strong>
            No refund or partial refund of any fees paid hereunder or any other fees will be made for any reason
          </strong>
          <span style="font-weight: 400;">.</span>
        </p>
        <p>
          <strong>6.5</strong>
          <strong>Breaches of this Agreement</strong>
          <span style="font-weight: 400;">
            . Without prejudice to our other rights under this Agreement, if you breach this Agreement in any way, we
            may take such action as we deem appropriate to deal with the breach, including suspending your access,
            charging you fees to compensate for our lost revenue and/or bringing Court proceedings against you.&nbsp;
            You hereby grant SingularityNET the right to take steps SingularityNET believes are reasonably necessary or
            appropriate to enforce and/or verify compliance with any part of this Agreement. You agree that
            SingularityNET has the right, without liability to you, to disclose any data and/or information to law
            enforcement authorities, government officials, and/or a third party, as SingularityNET believes is
            reasonably necessary or appropriate to enforce and/or verify compliance with any part of this Agreement
            (including but not limited to SingularityNET&rsquo;s right to cooperate with any legal process relating to
            your use of the AI Store or the Services and/or Content, and/or a third-party claim that your use of the AI
            Store, Services and/or Content is unlawful and/or infringes such third party&rsquo;s rights).
          </span>
        </p>
        <p>
          <strong>6.6 Compliance with laws, statutes, ordinance and regulations</strong>
          <span style="font-weight: 400;">.</span>
          <span style="font-weight: 400;">
            You agree to comply with all local, state, federal, and national laws, statutes, ordinances, and regulations
            that apply to your use of the AI Store or the Services and/or Content.&nbsp;
          </span>
        </p>
        <p>
          <strong>6.7</strong>
          <strong>Electronic transactions</strong>
          <span style="font-weight: 400;">
            . Risk of loss for all electronically delivered transactions pass to the acquirer upon electronic
            transmission to the recipient.
          </span>
        </p>
        <p>
          <strong>6.8 Law, Jurisdiction, Arbitration</strong>
          <span style="font-weight: 400;">.&nbsp;</span>
        </p>
        <p>
          <strong>6.8.1</strong>
          <span style="font-weight: 400;">
            This Agreement will be governed by and interpreted according to the law of the Netherlands.
          </span>
        </p>
        <p>
          <strong>6.8.2</strong>
          <span style="font-weight: 400;">
            Specifically excluded from application to this Agreement is the United Nations Convention on the
            International Sale of Goods.&nbsp;
          </span>
        </p>
        <p>
          <strong>6.8.3</strong>
          <span style="font-weight: 400;">
            To expedite resolution and reduce the cost of any dispute, controversy or claim, past, present, or future,
            between us, including without limitation any dispute or claim related to or arising out of this Agreement
            (&ldquo;
          </span>
          <strong>Dispute</strong>
          <span style="font-weight: 400;">
            &rdquo;), you and us may attempt to negotiate any Dispute informally (the &ldquo;
          </span>
          <strong>Informal Negotiations</strong>
          <span style="font-weight: 400;">
            &rdquo;) before initiating any arbitration or Court proceeding. Such Informal Negotiations will commence
            upon written notice.&nbsp;&nbsp;
          </span>
        </p>
        <p>
          <strong>6.8.4 </strong>
          <span style="font-weight: 400;">
            If a Dispute is not resolved through Informal Negotiations and you live in the EU, you and us agree to try
            to resolve any and all Disputes, using the EU Online Dispute Resolution platform to reach an out-of-court
            settlement. The EU Online Dispute Resolution platform is developed and operated by the European Commission.
            The EU Online Dispute Resolution platform is user-friendly, multilingual and accessible to all. Everything
            is done in four, simple steps:&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>i</strong>
          <span style="font-weight: 400;">) You fill in an online complaint form and submits it;&nbsp;</span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>ii</strong>
          <span style="font-weight: 400;">) the complaint is sent to Us;&nbsp;</span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iii</strong>
          <span style="font-weight: 400;">
            ) Once You and Us agree on an Alternative Dispute Resolution entity to handle the dispute, the EU Online
            Dispute Resolution platform transfers automatically the complaint to that entity;&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iv</strong>
          <span style="font-weight: 400;">
            ) The Alternative Dispute Resolution entity handles the case entirely online and reaches an outcome in 90
            days.
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">EU Online Dispute Resolution website </span>
          <a href="https://webgate.ec.europa.eu/odr/">
            <span style="font-weight: 400;">https://webgate.ec.europa.eu/odr/</span>
          </a>
        </p>
        <p>
          <span style="font-weight: 400;">Our email: legal@singualritynet.io.&nbsp;</span>
        </p>
        <p>
          <strong>6.8.5</strong>
          <span style="font-weight: 400;">
            If you do not live in the EU or if a Dispute is not resolved through Informal Negotiations or the European
            Commission&rsquo;s Online Dispute Resolution platform, you and us agree on the following:&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>i</strong>
          <span style="font-weight: 400;">
            ) Binding Arbitration. Except for any disputes, claims, suits, actions, causes of action, demands or
            proceedings (collectively, &ldquo;
          </span>
          <strong>Disputes</strong>
          <span style="font-weight: 400;">
            &rdquo;) in which either party seeks to bring an individual action in small claims court or seeks injunctive
            or other equitable relief for the alleged unlawful use of intellectual property, including, without
            limitation, copyrights, trademarks, trade names, logos, trade secrets or patents,
          </span>
          <strong>
            the parties (a) waive respective rights to have any and all Disputes arising from or related to this
            Agreement resolved in a court, and (b) waive respective rights to a jury trial. Instead, the parties will
            arbitrate Disputes through binding arbitration
          </strong>
          <span style="font-weight: 400;">
            (which is the referral of a Dispute to one or more persons charged with reviewing the Dispute and making a
            final and binding determination to resolve it instead of having the Dispute decided by a judge or jury in
            court).&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>ii</strong>
          <span style="font-weight: 400;">) No Class Arbitrations, Class Actions or Representative Actions. </span>
          <strong>
            Any Dispute arising out of or related to this Agreement is personal and will be resolved solely through
            individual arbitration and will not be brought as a class arbitration, class action or any other type of
            representative proceeding. There will be no class arbitration or arbitration in which an individual attempt
            to resolve a Dispute as a representative of another individual or group of individuals. Further, a Dispute
            cannot be brought as a class or other type of representative action, whether within or outside of
            arbitration, or on behalf of any other individual or group of individuals
          </strong>
          <span style="font-weight: 400;">.&nbsp;</span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iii</strong>
          <span style="font-weight: 400;">
            ) Notice and Informal Dispute Resolution. Each party will notify the other party in writing of any
            arbitrable or small claims Dispute within thirty (30) days of the date it arises, so that the parties can
            attempt in good faith to resolve the Dispute informally. Notice to SingularityNET shall be sent by e-mail at
          </span>
          <strong>legal@singularitynet.io</strong>
          <span style="font-weight: 400;">
            . Notice to you shall be by email to the email address provided to SingularityNET. Your notice must include
            (a) your name, postal address, email address and telephone number, (b) a description in reasonable detail of
            the nature or basis of the Dispute, and (c) the specific relief that you are seeking. If you and us cannot
            agree how to resolve the Dispute within thirty (30) days after the date notice is received by the applicable
            party, then either you or us may, as appropriate and in accordance with this section commence an arbitration
            proceeding or, to the extent specifically provided for in section 6.8.5(i), file a claim in court.&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>iv</strong>
          <span style="font-weight: 400;">
            ) Process. Any arbitration will occur in the Netherlands. Arbitration will be conducted confidentially by a
            single arbitrator in accordance with the Arbitration Rules of the Netherlands Arbitration Institute (&ldquo;
          </span>
          <strong>NAI Rules</strong>
          <span style="font-weight: 400;">
            &rdquo;) for the time being in force, which rules are deemed to be incorporated by reference in this clause.
            The language of the arbitration shall be English. The courts located in the Netherlands will have exclusive
            jurisdiction over any appeals and the enforcement of an arbitration award.&nbsp;&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>v</strong>
          <span style="font-weight: 400;">
            ) Authority of Arbitrator. The arbitrator will have (a) the exclusive authority and jurisdiction to make all
            procedural and substantive decisions regarding a Dispute, including the determination of whether a Dispute
            is arbitrable, and (b) the authority to grant any remedy that would otherwise be available in court;
            provided, however, that the arbitrator does not have the authority to conduct a class arbitration or a
            representative action, which is prohibited by this Agreement. The arbitrator may only conduct an individual
            arbitration and may not consolidate more than one individual&rsquo;s claims, preside over any type of class
            or representative proceeding or preside over any proceeding involving more than one individual.&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">(</span>
          <strong>vi</strong>
          <span style="font-weight: 400;">
            ) NAI Rules. NAI rules and additional information about the Netherlands Arbitration Institute are available
            on the Netherlands Arbitration Institute website (http://www.nai-nl.org). By agreeing to be bound by this
            Agreement, you either (i) acknowledge and agree that you have read and understand the NAI rules, or (ii)
            waive your opportunity to read the NAI rules and any claim that the NAI rules are unfair or should not apply
            for any reason.
          </span>
        </p>
        <p>
          <strong>6.8.6</strong>
          <strong>Unilateral hybrid jurisdiction</strong>
          <span style="font-weight: 400;">. </span>
          <strong>
            In the event that SingularityNET does not rely on arbitration, it reserves the right to bring an action
            before the Dutch Courts, the Courts of your domicile or any other court, in which case the competent
            jurisdiction law shall be applicable
          </strong>
          <span style="font-weight: 400;">.</span>
        </p>
        <p>
          <strong>6.8.7</strong>
          <strong>Time limitation</strong>
          <span style="font-weight: 400;">. </span>
          <strong>
            You agree that any claim you may have arising out of or related to your business relationship with us must
            be filed within one year after such claim arose; otherwise, your claim is permanently barred
          </strong>
          <span style="font-weight: 400;">.</span>
        </p>
        <p>
          <strong>6.9</strong>
          <span style="font-weight: 400;">
            Contact. All notices provided by a party in connection with this Agreement will be deemed given as of the
            day they are received either by email, messenger, delivery service, postage prepaid, certified or
            registered, return receipt requested, and addressed as follows:&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">Email: legal@singularitynet.io</span>
        </p>
        <p>
          <span style="font-weight: 400;">Address:&nbsp;</span>
        </p>
        <p>
          <span style="font-weight: 400;">SingularityNET</span>
        </p>
        <p>
          <span style="font-weight: 400;">Barbara Strozzilaan 362</span>
        </p>
        <p>
          <span style="font-weight: 400;">1083 HN Amsterdam</span>
        </p>
        <p>
          <span style="font-weight: 400;">The Netherlands</span>
        </p>
        <p>
          <span style="font-weight: 400;">
            Your address for such notices is your email address and/or physical address that you have provided to us.
          </span>
        </p>
        <p>
          <strong>6.10</strong>
          <span style="font-weight: 400;">
            This is our last agreement written by lawyers. The next one will be written by AI.
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">
            If you have any questions regarding this Agreement, please contact us.&nbsp;
          </span>
        </p>
        <p>
          <span style="font-weight: 400;">Last Updated: March 29, 2019</span>
        </p>
      </div>`
        )}
    </Fragment>
);
